import React, { FunctionComponent, SyntheticEvent, useEffect } from 'react';

import { useApolloClient } from '@apollo/react-hooks';
import { Checkbox } from 'semantic-ui-react';
import withStyles from 'react-jss';

import { ClassProp } from 'helpers/types';
import { Theme } from 'config';

type Props = {
  classes: ClassProp<ReturnType<typeof styles>>;
};

const styles = (theme: Theme) => ({
  container: {
    display: 'flex',
    width: '100%',
    padding: '0 1rem',
    justifyContent: 'space-between',
  },
  checkBox: {
    padding: '0.750rem !important',
    '& *': {
      fontSize: '.850rem !important',
      color: `${theme.darkGray} !important`,
      whiteSpace: 'nowrap !important',
      fontWeight: 'normal !important',
    },
  },
});

const ShowKeyMetricDeltas: FunctionComponent<Props> = ({ classes }) => {
  const client = useApolloClient();

  useEffect(() => {
    client.writeData({ data: { showDeltas: false } });
  }, []);

  const onChange = (
    _: SyntheticEvent<HTMLElement, Event>,
    { checked }: any,
  ) => {
    client.writeData({ data: { showDeltas: checked } });
  };

  return (
    <div className={classes.container}>
      <Checkbox
        className={classes.checkBox}
        label="Show Deltas"
        onChange={onChange}
      />
    </div>
  );
};
export default withStyles(styles)(ShowKeyMetricDeltas);
